import axios from 'axios';

const jwt = 'jwt';

export function setToken(token) {
  localStorage.setItem(jwt, token);
}

export function getToken() {
  return localStorage.getItem(jwt);
}

export function resetToken() {
  localStorage.removeItem(jwt);
  delete axios.defaults.headers.common.Authorization;
}

export function setJwtHeaders() {
  const token = getToken();

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js